import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/hosting', label: 'Hosting' },
    { path: '/vps', label: 'VPS' },
    { path: '/dominios', label: 'Dominios' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/blog', label: 'Blog' },
    { path: '/soporte', label: 'Soporte' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md'
          : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/be576f6491539e09547f155b96a8505c/654d7271eebe648b023e28c3cac0cad0.png"
              alt="EhostingChile.com"
              className="h-11 sm:h-14 w-auto"
            />
          </Link>

          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors cursor-pointer whitespace-nowrap text-sm xl:text-base ${
                  isActive(link.path)
                    ? 'text-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <Link
            to="/contratar"
            className="hidden lg:block bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 xl:px-6 py-2 xl:py-2.5 rounded-lg font-medium hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap text-sm xl:text-base"
          >
            Contratar Ahora
          </Link>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-gray-700 cursor-pointer p-1"
            aria-label="Menú"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-3 pb-4 border-t border-gray-200 pt-4">
            <nav className="flex flex-col space-y-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`font-medium transition-colors cursor-pointer px-3 py-2.5 rounded-lg ${
                    isActive(link.path)
                      ? 'text-blue-600 bg-blue-50'
                      : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/contratar"
                onClick={() => setIsMobileMenuOpen(false)}
                className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-3 rounded-lg font-medium text-center whitespace-nowrap mt-2"
              >
                Contratar Ahora
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
